import { all, takeLatest, call, fork, put, select, take } from "redux-saga/effects";
import { messages, success, deleteData } from "../../components/messageBox";
import * as types from "../../constants/actionTypes";
import moment from "moment";
import Config from "../../service/Config";
import Endpoint from "../../service/Endpoint";
import { GET, POST } from "../../service/api";
import { Header } from "../../constants/headers";
import { setLoader } from "./actions";

const getStateModuleDokter = (state) => state.ModuleDokter;

export function* getDataDokter(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    if (params.value == "all") {
      const _body = {
        id: _id,
      };
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_LIST_GET, _body);

      if (response.acknowledge == 1) {
        yield put({ type: types.MODULE_DOKTER_DATA_GET_ALL_SUCCESS, value: response.data });
      } else {
        messages("Error", "Gagal memuat data", "error", false, false);
      }
    } else if (params.value >= 0) {
      const _body = {
        detail: params.value,
      };
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_DETAIL_GET, _body);

      if (response.acknowledge == 1) {
        const dataDokter = response.data;
        let _formEdit = {
          f_id_dokter: dataDokter.f_id_dokter,
          f_kode_dokter: dataDokter.f_kode_dokter,
          f_nama_dokter: dataDokter.f_nama_dokter,
          f_tanggal_lahir: dataDokter.f_tanggal_lahir,
          f_jenis_kelamin: dataDokter.f_jenis_kelamin,
          f_email_dokter: dataDokter.f_email_dokter,
          f_password_dokter: dataDokter.f_password_dokter,
          f_telepon_dokter: dataDokter.f_telepon_dokter,
          f_no_alamat_dokter: dataDokter.f_no_alamat_dokter,
          f_catatan: dataDokter.f_catatan,
          f_id_negara: dataDokter.f_id_negara,
          temp_lokasi: [dataDokter.f_id_provinsi, dataDokter.f_id_kabupaten, dataDokter.f_id_kecamatan, dataDokter.f_id_desa],
        };
        yield put({ type: types.MODULE_DOKTER_DATA_GET_DETAIL_SUCCESS, payload: _formEdit });
      }
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getRiwayatPenyakitPasien(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    if (params.value) {
      const _body = {
        id: 1,
      };
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_REKAMMEDIS_RIWAYAT_PENYAKIT_PASIEN_POST, _body);

      if (response.acknowledge == 1) {
        const dataRiwayatPenyakitPasien = response.data;
        yield put({ type: types.MODULE_DOKTER_RIWAYAT_PENYAKIT_PASIEN_SUCCESS, payload: dataRiwayatPenyakitPasien });
      }
    } else {
      messages("Error", "Gagal memuat data riwayat penyakit", "error", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* validateDokterCode(params) {
  try {
    yield put(setLoader(true));

    if (params.value) {
      const _body = {
        "detail": params.value,
      };
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_DETAIL_GET, _body);

      if (response.acknowledge == 1) {
        const dataDokter = response.data;
        let _formEdit = {
          f_id_dokter: dataDokter.f_id_dokter,
          f_kode_dokter: dataDokter.f_kode_dokter,
          f_nama_dokter: dataDokter.f_nama_dokter,
          f_tanggal_lahir: dataDokter.f_tanggal_lahir,
          f_jenis_kelamin: dataDokter.f_jenis_kelamin,
          f_email_dokter: dataDokter.f_email_dokter,
          f_password_dokter: dataDokter.f_password_dokter,
          f_telepon_dokter: dataDokter.f_telepon_dokter,
          f_no_alamat_dokter: dataDokter.f_no_alamat_dokter,
          f_catatan: dataDokter.f_catatan,
          f_id_negara: dataDokter.f_id_negara,
          temp_lokasi: [dataDokter.f_id_provinsi, dataDokter.f_id_kabupaten, dataDokter.f_id_kecamatan, dataDokter.f_id_desa],
        };
        yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_CARI_DOKTER, property: "isExist", value: 20 });
        yield put({ type: types.MODULE_DOKTER_VALIDATE_CODE_SUCCESS, payload: _formEdit });
        messages("Pencarian Berhasil", "Anda dapat melakukan pengisian form dokter praktek.", "success", false, false);
      } else {
        yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_CARI_DOKTER, property: "isExist", value: 10 });
        messages("Maaf", "Data dokter tidak ditemukan.", "warning", false, false);
      }
    } else {
      yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_CARI_DOKTER, property: "isExist", value: 10 });
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getMasterData() {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    let _body = {
      MasterData: [
        {
          ObjectName: "listJenisKelamin",
        },
        {
          ObjectName: "listNegara",
        },
        {
          ObjectName: "listPoli",
          id: _id,
        },
      ],
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.GET_LIST_MASTER_DATA, _body);
    yield all(
      yield put({ type: types.MODULE_DOKTER_MASTER_DATA_SUCCESS, property: "listJenisKelamin", value: response.data.listJenisKelamin }),
      yield put({ type: types.MODULE_DOKTER_MASTER_DATA_SUCCESS, property: "listNegara", value: response.data.listNegara }),
      yield put({ type: types.MODULE_DOKTER_MASTER_DATA_SUCCESS, property: "listPoli", value: response.data.listPoli })
    );
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getListDokterPraktek() {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_DOKTER_LIST_DOKTER_PRAKTEK_GET + _id);
    yield all(yield put({ type: types.MODULE_DOKTER_DATA_GET_LIST_DOKTER_PRAKTEK_SUCCESS, value: response.data }));
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* postForm(params) {
  try {
    yield put(setLoader(true));

    let stateModuleDokter = yield select(getStateModuleDokter);
    const _data = stateModuleDokter.formDokter;
    const _body = {
      // "f_id_dokter": _data.f_id_dokter,
      f_kode_dokter: _data.f_kode_dokter,
      f_nama_dokter: _data.f_nama_dokter,
      f_tanggal_lahir: moment(_data.f_tanggal_lahir).format("YYYY-MM-DD"),
      f_jenis_kelamin: _data.f_jenis_kelamin,
      f_email_dokter: _data.f_email_dokter,
      f_telepon_dokter: _data.f_telepon_dokter,
      f_no_alamat_dokter: _data.f_no_alamat_dokter,
      f_catatan: null,
      f_id_negara: _data.f_id_negara,
      f_id_provinsi: _data.temp_lokasi[0],
      f_id_kabupaten: _data.temp_lokasi[1],
      f_id_kecamatan: _data.temp_lokasi[2],
      f_id_desa: _data.temp_lokasi[3],
    };

    if (!params.value) {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_CREATE_POST, _body, { headers: Header() });
      if (response.acknowledge == 1) {
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    } else {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_UPDATE_POST, { ..._body, f_id_dokter: params.value }, { headers: Header() });
      if (response.acknowledge == 1) {
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* postFormDokterPraktek(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    let stateModuleDokter = yield select(getStateModuleDokter);
    const _data = stateModuleDokter.formDokterPraktek;
    const _body = {
      f_periode_mulai: moment(_data.f_periode_mulai).format('YYYY-MM-DD HH:mm:ss'),
      f_periode_selesai: _data.status_periode_selesai ? _data.f_periode_selesai : null,
      f_gaji: null,
      f_id_dokter: _data.f_id_dokter,
      f_id_klinik: _id,
      f_id_poli: _data.f_id_poli,
    };

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_CREATE_DOKTER_PRAKTEK_POST, _body, { headers: Header() });
    if (response.acknowledge == 1) {
      messages("Berhasil", response.message, "success", false, params.history);
    } else {
      messages("Maaf", response.message, "warning", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* postFormJadwalPraktek(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;

    let stateModuleDokter = yield select(getStateModuleDokter);
    let finalJadwalPraktek = [];
    const _dataJadwalPraktek = stateModuleDokter.formJadwalPraktek.f_jadwal_praktek;
    const _idDokterPraktek = stateModuleDokter.formJadwalPraktek.f_id_dokter_praktek;
    const _listHari = stateModuleDokter.formJadwalPraktek.f_list_hari;
    const _listJadwalPraktek = stateModuleDokter.countJadwalPraktek;

    _listHari.map((hari) => {
      const _currentJadwalPraktek = _listJadwalPraktek["countJP_" + hari];
      _currentJadwalPraktek.map((obj) => {
        const _body = {
          f_jam_mulai: moment(_dataJadwalPraktek["f_jam_mulai_" + hari + "_" + obj.index]).format('HH:mm:ss'),
          f_jam_selesai: moment(_dataJadwalPraktek["f_jam_selesai_" + hari + "_" + obj.index]).format('HH:mm:ss'),
          f_estimasi_waktu: _dataJadwalPraktek["f_estimasi_" + hari + "_" + obj.index],
          f_catatan: null,
          f_id_dokter_praktek: _idDokterPraktek,
          f_id_hari: hari,
        };
        if (_body.f_jam_mulai && _body.f_jam_selesai && _body.f_estimasi_waktu && _body.f_id_dokter_praktek && _body.f_id_hari) {
          finalJadwalPraktek.push(_body);
        }
      });
    });

    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_CREATE_JADWAL_PRAKTEK_POST, { jadwal_praktek_dokter: finalJadwalPraktek }, { headers: Header() });
    if (response.acknowledge == 1) {
      messages("Berhasil", response.message, "success", false, params.history);
    } else {
      messages("Maaf", response.message, "warning", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

//diagnosa

export function* getDropdownListLayanan(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _body = {
      id: _id,
      poliklinik: params.value,
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_LAYANAN_DROPDOWN_LIST_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_DOKTER_DROPDOWN_LAYANAN_GET_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getDetailLayananByDropdown(params) {
  try {
    yield put(setLoader(true));

    const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_LAYANAN_DROPDOWN_DETAIL_GET + params.value);

    if (response.acknowledge == 1) {
      const _data = response.data;
      const _value = {
        f_id_layanan: params.value,
        f_nama_layanan: _data.f_nama_layanan,
        f_tarif_layanan: _data.f_tarif_layanan,
        f_tarif_administrasi: _data.f_status_administrasi == 1 ? _data.f_tarif_administrasi : 0,
        f_status_administrasi: _data.f_status_administrasi == 1 ? true : false,
        f_nama_poliklinik: _data.f_nama_poliklinik,
        isDisabled: _data.f_status_administrasi == 1 ? true : false,
      };
      yield put({ type: types.MODULE_DOKTER_LISTDATA_LAYANAN_GET_SUCCESS, value: _value });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* submitModalLayanan(params) {
  try {
    yield put(setLoader(true));

    let stateModuleDokter = yield select(getStateModuleDokter);
    const _data = stateModuleDokter.formDokter;
    const _body = {
      f_kode_dokter: _data.f_kode_dokter,
      f_nama_dokter: _data.f_nama_dokter,
      f_tanggal_lahir: _data.f_tanggal_lahir,
      f_jenis_kelamin: _data.f_jenis_kelamin,
      f_email_dokter: _data.f_email_dokter,
      f_telepon_dokter: _data.f_telepon_dokter,
      f_no_alamat_dokter: _data.f_no_alamat_dokter,
      f_catatan: null,
      f_id_negara: _data.f_id_negara,
      f_id_provinsi: _data.temp_lokasi[0],
      f_id_kabupaten: _data.temp_lokasi[1],
      f_id_kecamatan: _data.temp_lokasi[2],
      f_id_desa: _data.temp_lokasi[3],
    };

    if (!params.value) {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_CREATE_POST, _body, { headers: Header() });
      if (response.acknowledge == 1) {
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    } else {
      const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_UPDATE_POST, { ..._body, f_id_dokter: params.value }, { headers: Header() });
      if (response.acknowledge == 1) {
        messages("Berhasil", response.message, "success", false, params.history);
      } else {
        messages("Error", response.message, "error", false, false);
      }
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* addLayananToList() {
  try {
    yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_LAYANAN, property: "modalLoading", value: true });

    let stateModuleDokter = yield select(getStateModuleDokter);
    const _data = stateModuleDokter.modalListLayanan;
    let currentListDataLayanan = stateModuleDokter.dataListLayanan;
    const _value = {
      f_id_layanan: _data.f_id_layanan,
      f_nama_layanan: _data.f_nama_layanan,
      f_tarif_layanan: _data.f_tarif_layanan,
      f_tarif_administrasi: _data.f_tarif_administrasi,
      f_status_administrasi: _data.f_status_administrasi,
      f_nama_poliklinik: _data.f_nama_poliklinik,
    };

    currentListDataLayanan.push(_value);

    yield put({ type: types.MODULE_DOKTER_HANDLE_ADD_LAYANAN_TO_LIST_SUCCESS, value: currentListDataLayanan });

    yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_LAYANAN, property: "modalLoading", value: false });
  } catch (error) {
    yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_LAYANAN, property: "modalLoading", value: false });
    messages("Error", error, "error", false, false);
  }
}

//obat

export function* getDropdownListObat() {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _body = {
      id: _id,
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_OBAT_DROPDOWN_LIST_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_DOKTER_DROPDOWN_OBAT_GET_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* getDetailObatByDropdown(params) {
  try {
    yield put(setLoader(true));

    const response = yield call(GET, Config.BASE_URL + Endpoint.MODULE_OBAT_DROPDOWN_DETAIL_GET + params.value);
    if (response.acknowledge == 1) {
      const _data = response.data;
      const _value = {
        f_id_obat: _data.f_id_obat,
        f_nama_obat: _data.f_nama_obat,
        f_kode_obat: _data.f_kode_obat,
        f_stok_obat: _data.f_stok_obat,
        f_harga_obat: _data.f_harga_obat,
        f_nama_produsen: _data.f_nama_produsen,
      };
      yield put({ type: types.MODULE_DOKTER_LISTDATA_OBAT_GET_SUCCESS, value: _value });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* submitModalObat(params) {
  try {
    yield put(setLoader(true));

    // let stateModuleDokter = yield select(getStateModuleDokter)
    // const _data = stateModuleDokter.formDokter
    // const _body = {
    //     "f_kode_dokter": _data.f_kode_dokter,
    //     "f_nama_dokter": _data.f_nama_dokter,
    //     "f_tanggal_lahir": _data.f_tanggal_lahir,
    //     "f_jenis_kelamin": _data.f_jenis_kelamin,
    //     "f_email_dokter": _data.f_email_dokter,
    //     "f_telepon_dokter": _data.f_telepon_dokter,
    //     "f_no_alamat_dokter": _data.f_no_alamat_dokter,
    //     "f_catatan": null,
    //     "f_id_negara": _data.f_id_negara,
    //     "f_id_provinsi": _data.temp_lokasi[0],
    //     "f_id_kabupaten": _data.temp_lokasi[1],
    //     "f_id_kecamatan": _data.temp_lokasi[2],
    //     "f_id_desa": _data.temp_lokasi[3]
    // }

    // if(!params.value){
    //     const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_CREATE_POST, _body, { headers: Header() });
    //     if (response.acknowledge == 1) {
    //         messages("Berhasil", response.message, "success", false, params.history);
    //     }else{
    //         messages("Error", response.message, "error", false, false);
    //     }
    // }else{
    //     const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_UPDATE_POST, {..._body, "f_id_dokter": params.value}, { headers: Header() });
    //     if (response.acknowledge == 1) {
    //         messages("Berhasil", response.message, "success", false, params.history);
    //     }else{
    //         messages("Error", response.message, "error", false, false);
    //     }
    // }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* addObatToList() {
  try {
    yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_OBAT, property: "modalLoading", value: true });

    let stateModuleDokter = yield select(getStateModuleDokter);
    const _data = stateModuleDokter.modalListObat;
    let currentListDataLayanan = stateModuleDokter.dataListObat;
    const _value = {
      f_id_obat: _data.f_id_obat,
      f_nama_obat: _data.f_nama_obat,
      f_kode_obat: _data.f_kode_obat,
      f_harga_obat: _data.f_harga_obat,
      f_jmlh_obat: _data.f_jmlh_obat,
      f_dosis_obat: _data.f_dosis_obat,
      f_harga_total_obat: _data.f_jmlh_obat * _data.f_harga_obat,
    };

    currentListDataLayanan.push(_value);

    yield put({ type: types.MODULE_DOKTER_HANDLE_ADD_OBAT_TO_LIST_SUCCESS, value: currentListDataLayanan });

    yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_OBAT, property: "modalLoading", value: false });
  } catch (error) {
    yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_FORM_MODAL_OBAT, property: "modalLoading", value: false });
    messages("Error", error, "error", false, false);
  }
}

export function* getDropdownICD() {
  try {
    yield put(setLoader(true));
    const response = yield call(GET, Config.BASE_URL + Endpoint.GET_LIST_ICD);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_DOKTER_DROPDOWN_ICD_GET_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* checkStatusDiagnosa(params) {
  try {
    yield put(setLoader(true));
    const _id_poli = JSON.parse(localStorage.getItem("UserData")).f_id_poli;
    const _body = {
      f_id_reservasi: params.value,
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_CHECK_STATUS_DIAGNOSA_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_DOKTER_CHECK_STATUS_DIAGNOSA_SUCCESS, value: response.data.f_status, data: response.data });
      yield call(getDropdownListLayanan, { value: _id_poli });
      yield call(getDropdownListObat);

      if (response.data.f_status == 1) {
        yield call(toDiagnosaStep2, { value: params.value });
      } else if (response.data.f_status == 2) {
        yield call(toDiagnosaStep3, { value: params.value });
      } else if (response.data.f_status == 3) {
        // yield call(toDiagnosaStep4(params.value))
      }
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* toDiagnosaStep1(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _body = {
      f_id_reservasi: params.value,
      prefix: moment().format("YYMMDD"),
      f_tgl_buat: moment().format("YYYY-MM-DD HH:mm:ss"),
      f_status: "0",
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_DIAGNOSA1_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_DOKTER_HANDLE_STATE_DIAGNOSA1_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* submitFormDiagnosa1(params) {
  try {
    yield put(setLoader(true));
    const _body = {
      f_id_reservasi: params.value,
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_SUBMIT_DIAGNOSA1_POST, _body);

    if (response.acknowledge == 1) {
      // messages("Berhasil", response.message, "success", false, false);
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* submitFormDiagnosa2(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    let stateModuleDokter = yield select(getStateModuleDokter);
    const _data = stateModuleDokter.formDiagnosaStep2;
    const _body = {
      f_id_reservasi: params.value,
      f_berat_badan: _data.f_berat_badan,
      f_tinggi_badan: _data.f_tinggi_badan,
      f_suhu_tubuh: _data.f_suhu_tubuh,
      f_frekuensi_nafas: _data.f_frekuensi_nafas,
      f_nadi: _data.f_nadi,
      f_tekanan_darah_sistole: _data.f_tekanan_darah_sistole,
      f_tekanan_darah_diastole: _data.f_tekanan_darah_diastole,
      f_keluhan_pasien: _data.f_keluhan_pasien,
      //   f_status: "2",
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_DIAGNOSA2_POST, _body);

    if (response.acknowledge == 1) {
      // messages("Berhasil", response.message, "success", false, false);
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* toDiagnosaStep2(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _body = {
      f_id_reservasi: params.value,
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_DIAGNOSA2_POST, _body);

    if (response.acknowledge == 1) {
      yield put({ type: types.MODULE_DOKTER_TO_DIAGNOSA2_SUCCESS, value: response.data });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* submitFormDiagnosa3(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    let stateModuleDokter = yield select(getStateModuleDokter);
    const _data = stateModuleDokter.formDiagnosaStep3;
    let _listLayanan = stateModuleDokter.dataListLayanan.map((item) => {
      return {
        f_id_layanan: item.f_id_layanan,
        f_biaya_layanan: item.f_tarif_layanan,
        f_biaya_administrasi: item.f_status_administrasi ? item.f_tarif_administrasi : "0",
      };
    });
    let _listObat = stateModuleDokter.dataListObat.map((item) => {
      return {
        f_id_obat: item.f_id_obat,
        // "f_dosis_obat": item.f_dosis_obat[0]+" x "+item.f_dosis_obat[1]+" hari",
        f_dosis_obat: item.f_dosis_obat,
        f_jmlh_obat: item.f_jmlh_obat,
        f_harga_total_obat: item.f_harga_total_obat,
      };
    });

    const _body = {
      f_id_reservasi: params.value,
      f_id_icd: _data.f_id_icd,
      f_diagnosa: _data.f_diagnosa,
      f_status: "3",
      listLayanan: _listLayanan,
      listObat: _listObat,
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_SUBMIT_DIAGNOSA3_POST, _body);

    if (response.acknowledge == 1) {
      // messages("Berhasil", response.message, "success", false, false);
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }

    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* toDiagnosaStep3(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    const _body = {
      f_id_reservasi: params.value,
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_DIAGNOSA3_POST, _body);
    if (response.acknowledge == 1) {
      const _response = response.data;
      let _dataListLayanan = _response.dataListLayanan.map((item) => {
        return {
          f_id_layanan: item.f_id_layanan,
          f_nama_layanan: item.f_nama_layanan,
          f_nama_poliklinik: item.f_nama_poliklinik,
          f_tarif_administrasi: item.f_tarif_administrasi,
          f_tarif_layanan: item.f_tarif_layanan,
          f_status_administrasi: item.f_status_administrasi == 1 ? true : false,
        };
      });
      yield put({
        type: types.MODULE_DOKTER_TO_DIAGNOSA3_SUCCESS,
        valueformDiagnosaStep3: _response.formDiagnosaStep3,
        valuedataListObat: _response.dataListObat,
        valuedataListLayanan: _dataListLayanan,
      });
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export function* submitFormDiagnosa4(params) {
  try {
    yield put(setLoader(true));
    const _id = JSON.parse(localStorage.getItem("UserData")).f_id_klinik;
    let stateModuleDokter = yield select(getStateModuleDokter);

    const _body = {
      f_id_reservasi: params.value,
    };
    const response = yield call(POST, Config.BASE_URL + Endpoint.MODULE_DOKTER_SUBMIT_DIAGNOSA4_POST, _body);

    if (response.acknowledge == 1) {
      messages("Berhasil", response.message, "success", false, params.history);
    } else {
      messages("Error", "Gagal memuat data", "error", false, false);
    }
    yield put(setLoader(false));
  } catch (error) {
    yield put(setLoader(false));
    messages("Error", error, "error", false, false);
  }
}

export default function* rootSaga() {
  yield all([
    takeLatest(types.MODULE_DOKTER_DATA_GET, getDataDokter),
    takeLatest(types.MODULE_DOKTER_MASTER_DATA, getMasterData),
    takeLatest(types.MODULE_DOKTER_SUBMIT_FORM, postForm),
    takeLatest(types.MODULE_DOKTER_VALIDATE_CODE, validateDokterCode),
    takeLatest(types.MODULE_DOKTER_SUBMIT_FORM_DOKTER_PRAKTEK, postFormDokterPraktek),
    takeLatest(types.MODULE_DOKTER_SUBMIT_FORM_JADWAL_PRAKTEK, postFormJadwalPraktek),
    takeLatest(types.MODULE_DOKTER_DATA_GET_LIST_DOKTER_PRAKTEK, getListDokterPraktek),
    takeLatest(types.MODULE_DOKTER_DROPDOWN_LAYANAN_GET, getDropdownListLayanan),
    takeLatest(types.MODULE_DOKTER_LISTDATA_LAYANAN_GET, getDetailLayananByDropdown),
    takeLatest(types.MODULE_DOKTER_SUBMIT_MODAL_LAYANAN, submitModalLayanan),
    takeLatest(types.MODULE_DOKTER_HANDLE_ADD_LAYANAN_TO_LIST, addLayananToList),
    takeLatest(types.MODULE_DOKTER_RIWAYAT_PENYAKIT_PASIEN, getRiwayatPenyakitPasien),

    takeLatest(types.MODULE_DOKTER_DROPDOWN_OBAT_GET, getDropdownListObat),
    takeLatest(types.MODULE_DOKTER_LISTDATA_OBAT_GET, getDetailObatByDropdown),
    takeLatest(types.MODULE_DOKTER_SUBMIT_MODAL_OBAT, submitModalObat),
    takeLatest(types.MODULE_DOKTER_HANDLE_ADD_OBAT_TO_LIST, addObatToList),
    takeLatest(types.MODULE_DOKTER_DROPDOWN_ICD_GET, getDropdownICD),

    takeLatest(types.MODULE_DOKTER_CHECK_STATUS_DIAGNOSA, checkStatusDiagnosa),
    takeLatest(types.MODULE_DOKTER_HANDLE_STATE_DIAGNOSA1, toDiagnosaStep1),
    takeLatest(types.MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA1, submitFormDiagnosa1),
    takeLatest(types.MODULE_DOKTER_TO_DIAGNOSA2, toDiagnosaStep2),
    takeLatest(types.MODULE_DOKTER_TO_DIAGNOSA3, toDiagnosaStep3),
    takeLatest(types.MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA2, submitFormDiagnosa2),
    takeLatest(types.MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA3, submitFormDiagnosa3),
    takeLatest(types.MODULE_DOKTER_SUBMIT_FORM_DIAGNOSA4, submitFormDiagnosa4),
  ]);
}
